import { createActions } from 'redux-actions'

const SEARCH_ELASTICSEARCH_DATA = 'SEARCH_ELASTICSEARCH_DATA'

export const elasticsearchAction = createActions(
  SEARCH_ELASTICSEARCH_DATA,
)
